<template>
  <div class="google-ad">
    <slot/>
  </div>
</template>
<script>
  export default {
    name: 'googleAd',
    mounted () {
      setTimeout(() => {
        console.log('this.$el.outerHTML--');
        console.log(this.$el.outerHTML);
        (adsbygoogle = window.adsbygoogle || []).push({});
        console.log('google-ad');
      }, 100);
    }
  };
</script>

<style scoped lang="less">

</style>
